/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type { PublicUseCaseResponse } from '../models/index';
import { PublicUseCaseResponseFromJSON, PublicUseCaseResponseToJSON } from '../models/index';

export interface PublicUseCaseRetrieveRequest {
  token: string;
}

/**
 *
 */
export class PublicApi extends runtime.BaseAPI {
  /**
   * Read-only use-case snapshot for share-token holders. No authentication required; access is gated by the token.
   */
  async publicUseCaseRetrieveRaw(
    requestParameters: PublicUseCaseRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PublicUseCaseResponse>> {
    if (requestParameters['token'] == null) {
      throw new runtime.RequiredError(
        'token',
        'Required parameter "token" was null or undefined when calling publicUseCaseRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/public/use_case/{token}/`.replace(
          `{${'token'}}`,
          encodeURIComponent(String(requestParameters['token'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PublicUseCaseResponseFromJSON(jsonValue));
  }

  /**
   * Read-only use-case snapshot for share-token holders. No authentication required; access is gated by the token.
   */
  async publicUseCaseRetrieve(
    requestParameters: PublicUseCaseRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PublicUseCaseResponse> {
    const response = await this.publicUseCaseRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
